import { Link, Navigate } from 'react-router-dom'
import { Inbox, FileText, ArrowRight } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { useUserProfile } from '@/hooks/useUserProfile'
import { Card } from '@/components/ui/card'
import { ActivityFeed } from '../components/ActivityFeed'

export function DashboardPage() {
  const { user, loading } = useAuth()
  const { profile } = useUserProfile()

  if (loading) return null
  if (!user) return <Navigate to="/sign-in" replace />

  const isProvider = !!profile?.linkedMemberId

  return (
    <div className="container mx-auto max-w-3xl px-4 py-12 space-y-8">
      <div>
        <h1 className="text-3xl font-bold">My Account</h1>
        {user.email && <p className="mt-1 text-sm text-muted-foreground">{user.email}</p>}
      </div>

      {isProvider && (
        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Provider Portal</h2>
          <div className="grid sm:grid-cols-2 gap-3">
            <Link to="/portal/requests" className="block">
              <Card className="p-5 hover:bg-muted/40 transition-colors h-full">
                <div className="flex items-start justify-between gap-3">
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <Inbox className="h-4 w-4 text-muted-foreground" />
                      <p className="font-medium">Service Requests</p>
                    </div>
                    <p className="text-xs text-muted-foreground">Open requests + upcoming and active bookings.</p>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground" />
                </div>
              </Card>
            </Link>
            <Link to="/portal/invoices" className="block">
              <Card className="p-5 hover:bg-muted/40 transition-colors h-full">
                <div className="flex items-start justify-between gap-3">
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <FileText className="h-4 w-4 text-muted-foreground" />
                      <p className="font-medium">Invoices</p>
                    </div>
                    <p className="text-xs text-muted-foreground">Submit invoices, track approval and payment.</p>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground" />
                </div>
              </Card>
            </Link>
          </div>
        </section>
      )}

      <ActivityFeed />
    </div>
  )
}
